import React from 'react'
import styles from './Skeleton.module.scss'

interface SkeletonProps extends React.PropsWithChildren {
  minWidth?: string
  maxWidth?: string
  width?: string
  minHeight?: string
  maxHeight?: string
  height?: string
}

function Skeleton(props: SkeletonProps) {
  const { children, minWidth, maxWidth, width, minHeight, maxHeight, height, ...other } = props
  return (
    <div
      style={{
        minWidth,
        minHeight,
        width,
        height,
        maxHeight,
        maxWidth,
      }}
      className={styles.skeleton}
      {...other}
    >
      {children}
    </div>
  )
}

export default Skeleton
